import * as React from 'react';
import { Popover, CloseButton, PopoverProps } from '@wix/design-system';
import s from './Tooltip.scss';
import { useOnWindowScroll } from '../../hooks/useOnWindowScroll';
import { useBreakpoint } from '../../providers/BreakpointProvider';
import { MediaDevices } from 'enums';

interface TooltipProps {
  onClose(): void;
  onOpen(): void;
  content: React.ReactNode;
  dataHook?: string;
  maxWidth?: string | number;
  placement?: PopoverProps['placement'];
  closePopoverSize?: 'medium' | 'large';
  moveBy?: { x: number; y: number };
  isOpenFromParent?: boolean;
  setIsOpenFromParent?: any;
}

export const Tooltip: React.FC<TooltipProps> = ({
  onClose,
  onOpen,
  content,
  children,
  dataHook,
  maxWidth = 300,
  placement = 'right',
  closePopoverSize = 'medium',
  moveBy = { x: 0, y: 0 },
  isOpenFromParent = false,
  setIsOpenFromParent,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const { currentBreakpoint } = useBreakpoint();
  const isDesktopView = currentBreakpoint === MediaDevices.Desktop;

  const handleClose = () => {
    onClose();
    setIsOpen(false);
    if (setIsOpenFromParent) {
      setIsOpenFromParent(false);
    }
  };
  const handleOpen = () => {
    onOpen();
    setIsOpen(true);
    if (setIsOpenFromParent) {
      setIsOpenFromParent(true);
    }
  };
  const tooglePopover = isOpen ? handleClose : handleOpen;

  const hoverProps = {
    onMouseEnter: handleOpen,
    onMouseLeave: handleClose,
  };

  const clickableProps = {
    onClick: tooglePopover,
    onClickOutside: handleClose,
  };

  useOnWindowScroll(handleClose);

  return (
    <Popover
      shown={isOpen || isOpenFromParent}
      dataHook={dataHook}
      maxWidth={maxWidth}
      placement={placement}
      showArrow={true}
      moveBy={moveBy}
      appendTo='scrollParent'
      {...(isDesktopView ? hoverProps : clickableProps)}
    >
      <Popover.Element>{children}</Popover.Element>
      <Popover.Content>
        <div className={s.featureTooltip}>
          <span className={s.content}>{content}</span>
          {!isDesktopView && (
            <CloseButton
              className={s.closeButton}
              size={closePopoverSize}
              skin='dark'
              onClick={handleClose}
            />
          )}
        </div>
      </Popover.Content>
    </Popover>
  );
};
